// src/pages/pentest/api/nav.jsx  (or wherever your API Nav lives)
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate, useLocation } from 'react-router-dom';

// Icons
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssignmentIcon from '@mui/icons-material/Assignment';
import StorageIcon from '@mui/icons-material/Storage';
import BugReportIcon from '@mui/icons-material/BugReport';
import DescriptionIcon from '@mui/icons-material/Description';
import AssessmentIcon from '@mui/icons-material/Assessment';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

function Nav() {
  const navigate = useNavigate();
  const location = useLocation();

  // extract pentest_id as the last segment
  const pathParts = location.pathname.replace(/\/$/, '').split('/').filter(Boolean);
  const pentest_id = pathParts[pathParts.length - 1];

  const [selectedTab, setSelectedTab] = useState(0);
  const [findingsAnchorEl, setFindingsAnchorEl] = useState(null);
  const [reportAnchorEl, setReportAnchorEl] = useState(null); // NEW: report menu anchor

  useEffect(() => {
    const path = location.pathname;
    if (/^\/pentest\/api\/dashboard\/.+$/.test(path)) setSelectedTab(0);
    else if (/^\/pentest\/api\/scope\/.+$/.test(path)) setSelectedTab(1);
    else if (/^\/pentest\/api\/assets\/.+$/.test(path)) setSelectedTab(2);
    else if (/^\/pentest\/api\/threat_model\/.+$/.test(path)) setSelectedTab(3);
    else if (/^\/pentest\/api\/exploits\/.+$/.test(path)) setSelectedTab(3);
    else if (/^\/pentest\/api\/report\/(pentest|executive|attestation)\/\d+$/.test(path)) setSelectedTab(4);
    else setSelectedTab(0);
  }, [location.pathname]);

  const handleTabChange = (event, newValue) => {
    // prevent tab change from navigating when opening dropdown tabs
    if (newValue === 4) return; // Report tab opens a menu
    setSelectedTab(newValue);
    switch (newValue) {
      case 0:
        navigate(`/pentest/api/dashboard/${pentest_id}`);
        break;
      case 1:
        navigate(`/pentest/api/scope/${pentest_id}`);
        break;
      case 2:
        navigate(`/pentest/api/assets/${pentest_id}`);
        break;
      default:
        break;
    }
  };

  // Findings menu
  const openFindingsMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setFindingsAnchorEl(e.currentTarget);
  };
  const closeFindingsMenu = () => setFindingsAnchorEl(null);
  const handleFindingsItem = (route) => {
    setFindingsAnchorEl(null);
    setSelectedTab(3);
    navigate(`/pentest/api/${route}/${pentest_id}`);
  };

  // NEW: Report menu
  const handleReportClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setReportAnchorEl(e.currentTarget);
  };
  const handleReportClose = () => setReportAnchorEl(null);
  const handleReportItem = (type) => {
    setReportAnchorEl(null);
    setSelectedTab(4);
    navigate(`/pentest/api/report/${type}/${pentest_id}`);
  };

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        p: 2,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        mb: 3,
      }}
    >
      <Box sx={{ mb: 1 }}>
        <Typography variant="h4" fontWeight="bold">
          Pentest
        </Typography>
      </Box>

      <Tabs value={selectedTab} onChange={handleTabChange} textColor="primary" indicatorColor="primary">
        <Tab icon={<DashboardIcon />} label="Dashboard" />
        <Tab icon={<AssignmentIcon />} label="Scope" />
        <Tab icon={<StorageIcon />} label="Assets" />
        <Tab
          icon={<BugReportIcon />}
          label={
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              Findings <ArrowDropDownIcon fontSize="small" />
            </Box>
          }
          onClick={openFindingsMenu}
        />
        {/* NEW: Report tab opens dropdown just like external nav */}
        <Tab
          icon={<DescriptionIcon />}
          label={
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              Report <ArrowDropDownIcon fontSize="small" />
            </Box>
          }
          onClick={handleReportClick}
        />
      </Tabs>

      {/* Findings Menu */}
      <Menu anchorEl={findingsAnchorEl} open={Boolean(findingsAnchorEl)} onClose={closeFindingsMenu}>
        <MenuItem onClick={() => handleFindingsItem('threat_model')}>Threat Model</MenuItem>
        <MenuItem onClick={() => handleFindingsItem('exploits')}>Exploits</MenuItem>
      </Menu>

      {/* NEW: Reports Menu (pentest/executive/attestation) */}
      <Menu anchorEl={reportAnchorEl} open={Boolean(reportAnchorEl)} onClose={handleReportClose}>
        <MenuItem onClick={() => handleReportItem('pentest')}>
          <DescriptionIcon style={{ marginRight: 8 }} /> Pentest Report
        </MenuItem>
        <MenuItem onClick={() => handleReportItem('executive')}>
          <AssessmentIcon style={{ marginRight: 8 }} /> Executive Report
        </MenuItem>
        <MenuItem onClick={() => handleReportItem('attestation')}>
          <EmojiEventsIcon style={{ marginRight: 8 }} /> Attestation
        </MenuItem>
      </Menu>
    </Box>
  );
}

export default Nav;
